module.exports = __webpack_public_path__ + "img/pro_one_3.d42c4fcc.jpg";